export const contextualToolsOpen = state => state.menu.get('contextual');
export const blurCanvas = state => state.menu.get('blurCanvas');
